exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-img-top[data-v-bc7d244c] {\n  max-height: 190px;\n}\nimg[data-v-bc7d244c] {\n  box-shadow: none;\n}\n.card-title img[data-v-bc7d244c], .card-text img[data-v-bc7d244c] {\n  display: inline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bc7d244c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Card.vue
// module id = 672
// module chunks = 3